module.exports = __webpack_public_path__ + "static/media/walking-with-dog.a1f9ab95.png";